module.exports = __webpack_public_path__ + "static/media/wolffox7.d0568107.jpg";